import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../../../../../common/element/Table";
import ToolManagmentCard from "../../../../../../../common/element/Card/ToolManagmnetCard";
import { Pagination } from "../../../../../../../common/pagination";
import ModernPagination from "../../../../../../../common/pagination/ModernPagination";

// Redux Imports
import { getCompanyAdhocToolsCandidatesCount } from "../../../../../../../redux/AdhocCompany/Companyadhocslice";
import {
  selectCompanyAdhocToolsCandidatesCountData,
  selectCompanyAdhocToolsCandidatesCountLoading,
} from "../../../../../../../redux/AdhocCompany/Companyadhocselectors";
import { useLocation } from "react-router-dom";
import { formatToolName } from "../../../../../../../common/Formatters.js/formatters";

const { Tr, Th, Td, THead, TBody } = Table;

const ToolsList = ({  }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const companyId = searchParams.get("companyId");
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);

  // Redux Selectors
  const toolsResponse = useSelector(selectCompanyAdhocToolsCandidatesCountData);
  const loading = useSelector(selectCompanyAdhocToolsCandidatesCountLoading);
  const toolsData = toolsResponse || []; 
  const totalCount = toolsResponse?.count || 0;
  const totalPages = Math.ceil(totalCount / filterlimit);
  console.log(toolsResponse ,"toolsDatatoolsData")
  useEffect(() => {
    if (companyId) {
      dispatch(
        getCompanyAdhocToolsCandidatesCount({
          page: filterpage,
          limit: filterlimit,
          company_id: companyId,
        })
      );
    }
  }, [dispatch, companyId, filterpage, filterlimit]);

  const handlePageChange = (page) => {
    setfilterpage(page);
  };

  return (
    <ToolManagmentCard>
      <div className="pb-4 border-b border-gray-200">
        <h2 className="font-lato font-semibold text-[16px] leading-[150%] text-[#101828] text-start text-start">
          Tools
        </h2>
      </div>

      <div className="py-6">
        <div className="border border-gray-200 rounded-lg overflow-hidden">
          <Table className="w-full text-sm text-gray-700">
            <THead>
              <Tr className="bg-[#F9F9FB] text-gray-600 text-xs">
                <Th className="py-3 px-4 text-left font-medium">S. No.</Th>
                <Th className="py-3 px-4 text-left font-medium">Tools Name</Th>
                <Th className="py-3 px-4 text-left font-medium">No. of Candidates</Th>
              </Tr>
            </THead>

            <TBody>
              {loading ? (
                <Tr>
                  <Td
                    colSpan={3}
                    className="text-center text-gray-500 py-6 text-sm"
                  >
                    Loading tools...
                  </Td>
                </Tr>
              ) : toolsData && toolsData.length > 0 ? (
                toolsData.map((item, index) => (
                  <Tr
                    key={item.id || index}
                    className="border-t border-gray-100 hover:bg-gray-50 transition-colors text-start"
                  >
                    <Td className="py-3 px-4">
                      {/* Calculate Serial Number based on page */}
                      {String((filterpage - 1) * filterlimit + index + 1).padStart(2, "0")}
                    </Td>
                    <Td className="py-3 px-4">
                      {formatToolName(item.tool_name || item.toolName || "-")}
                    </Td>
                    <Td className="py-3 px-4">
                      {item.no_of_candidates !== undefined && item.no_of_candidates !== null ? item.no_of_candidates : "[No. of Candidates]"}
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td
                    colSpan={3}
                    className="text-center text-gray-500 py-6 text-sm"
                  >
                    No tools found
                  </Td>
                </Tr>
              )}
            </TBody>
          </Table>
        </div>
      </div>

      <div className="flex justify-between items-center mt-3">
        {/* Left side - Pagination info */}
        <Pagination
          totalCount={totalCount}
          pageNumber={filterpage}
          displayPage={toolsData.length}
          UpdatePageLimit={setfilterlimit}
          UpdatePage={setfilterpage}
        />

        {/* Right side - Modern Pagination Controls */}
        {totalCount > 0 && totalPages > 1 && (
          <ModernPagination
            totalPages={totalPages}
            currentPage={filterpage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </ToolManagmentCard>
  );
};

export default ToolsList;